// extracted by mini-css-extract-plugin
export const ctaButton = "CTAButton-module--cta-button--5K3ho";
export const small = "CTAButton-module--small--2DYIO";
export const normal = "CTAButton-module--normal--3Sy50";
export const large = "CTAButton-module--large--3yvu1";
export const white = "CTAButton-module--white--1RnLg";
export const purple = "CTAButton-module--purple--Y3EhC";